<template>
    <div>
        <b-modal
            id="trademarkResponsibleFormModal"
            centered
            size="xl"
            no-close-on-backdrop
            ref="trademarkResponsibleFormModal"
            :title=" $t('trademarkResponsible.info')"
            :cancel-title=" $t('others.cancel_title')"
            :ok-title=" $t('others.ok_title')"
            cancel-variant="outline-secondary"
            @ok.prevent="addOrUpdate"
            hide-footer
        >
        <b-card no-body class="border mt-1">
            <b-card-header class="p-1">
              <b-card-title class="font-medium-2">
                <feather-icon icon="LockIcon" size="18" />
                <span class="align-middle ml-50">{{  $t('trademarkResponsible.responsible')  }}</span>
              </b-card-title>
            </b-card-header>
            <!--eslint-disable-->
            <table class="table table-striped table-bordered">
              <tbody>
                <tr v-for="trademarkResponsibleItem in trademarkResponsibleList" :key="trademarkResponsibleItem.id">
                  <td >
                      <b-form-checkbox @change="changeResponsible($event, trademarkResponsibleItem.id, trademarkResponsibleItem.mailContactTypeId)" />                                 
                  </td>
                  <td>{{  trademarkResponsibleItem.name  }}</td>
                  <td>{{  trademarkResponsibleItem.email  }}</td>
                  <td>
                    <b-form-select v-model="trademarkResponsibleItem.mailContactTypeId" value-field="id" text-field="name" :options="mailContactTypeList" />
                  </td>
                  <td>{{  trademarkResponsibleItem.responsibleField  }}</td>
                </tr>
              </tbody>
            </table>
          </b-card>
        </b-modal>
    </div>
</template>
<script>
export default{
  props: {
      getTrademarkResponsibleList: {type: Function},
    },
  data(){
    return {
      id: 0,
      trademarkResponsibleList:[],
      mailContactTypeList:[],
    }
  },
  methods:{
    changeResponsible(selected, clientResponsibleId, mailContactTypeId) {
      const controller = { name: 'TrademarkResponsible' }
      if (selected == true) {
        const data = { trademarkId: this.trademarkId, clientResponsibleId: clientResponsibleId, mailContactTypeId: mailContactTypeId  }
        const payload = { data: data, controller: controller }
        this.$store.dispatch('moduleAuth/save', payload).then((response) => {
          if (response.data.resultStatus == true) {
            this.getTrademarkResponsibleList()
            this.$SaveAlert()
          } else {
            this.$WarningAlert(response.data.resultMessage)
          }
        })
      }
    },
    showInfo(trademarkId, clientId) {
      this.$refs['trademarkResponsibleFormModal'].show()
          this.trademarkId= trademarkId
          const data = {clientId: clientId,trademarkId:trademarkId}
          const controller = {name: 'ClientResponsible', actionName:'GetClientResponsibleListForModules'}
          const payload = {data: data, controller: controller}
          this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
              if(response.data.resultStatus == true){    
                  this.trademarkResponsibleList = response.data.clientResponsibleList
                  this.mailContactTypeList = response.data.mailContactTypeList
              } else {
                  this.$bvModal.hide('trademarkResponsibleFormModal')
                  this.$WarningAlert(response.data.resultMessage)
              }  
          }) 
      }
  }
}
</script>